import React from "react";
import { InwardForm } from "./inwardForm";

const InwardRegister = () => {
  return (
    <>
      <InwardForm />
    </>
  );
};

export default InwardRegister;
